import Card from "components/card";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { getContainer } from "store/containerSlice";
import SearchInputField from "components/fields/SearchInputField";
import { RiErrorWarningFill } from "react-icons/ri";

import { resetContainerData } from "store/containerSlice";
import AddContainer from "./components/AddContainers";
import CardContainers from "./components/CardContainers";
import { CONTAINER_STATUS } from "constants";

const ContainerPage = ({ status }) => {
  const dispatch = useDispatch();
  const { containerData, containerLoading, containerError } = useSelector(
    (state) => state.containers
  );
  const { container: containerPharm = {} } = useSelector(
    (state) => state.auth.permissions || {}
  );

  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [searchText, setSearchText] = useState("");
  useEffect(() => {
    dispatch(resetContainerData());
  }, [dispatch, status]);
  const refreshList = () => {
    setRefreshTrigger((prev) => !prev);
  };
  useEffect(() => {
    dispatch(getContainer({ search: searchText, status: status?.enumVal }));
  }, [dispatch, status, searchText, refreshTrigger]);

  const containerList = useMemo(() => {
    if (!containerData?.data) return [];

    return containerData?.data;
  }, [containerData]);

  const { isDispatched, isLoaded, isArrived, isReceived, isCreated } = useMemo(
    () => ({
      isDispatched: status?.enumVal === CONTAINER_STATUS.DISPATCHED,
      isLoaded: status?.enumVal === CONTAINER_STATUS.LOADED,
      isArrived: status?.enumVal === CONTAINER_STATUS.ARRIVED,
      isReceived: status?.enumVal === CONTAINER_STATUS.RECEIVED,
      isCreated: status?.enumVal === CONTAINER_STATUS.CREATED,
    }),
    [status]
  );

  return (
    <div className=" ">
      <Card extra={"mt-3 w-full h-full p-3"}>
        <div className=" flex w-full flex-col  items-center justify-between md:flex-row">
          <h4 className="px-2 text-xl font-bold text-navy-700 dark:text-white">
            Containers Information
          </h4>
          <div className="flex flex-col  items-center justify-center gap-2 md:flex-row">
            <SearchInputField
              id="local-search"
              placeholder={"Search Container"}
              value={searchText ?? ""}
              onChange={(e) => setSearchText(e.target.value)}
              className="mt-0 lg:w-[300px]"
              shortcut="Ctrl K"
            />
            {containerPharm?.create && isCreated && (
              <AddContainer refreshList={refreshList} />
            )}
          </div>
        </div>
      </Card>

      <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
        {containerLoading && !containerList?.length ? (
          Array.from({ length: 2 }).map((_, i) => (
            <Card
              key={`skeleton-${i}`}
              extra={"w-full h-full p-3 animate-pulse"}
            >
              {/* Header */}
              <div className="mb-8 mt-2 flex w-full items-center justify-between">
                <div className="h-6 w-40 rounded bg-gray-300" />
                <div className="h-6 w-10 rounded bg-gray-300" />
              </div>

              {/* Body */}
              <div className="grid grid-cols-1 gap-2">
                {Array.from({ length: 4 }).map((_, idx) => (
                  <div
                    key={idx}
                    className="flex items-start justify-between px-3"
                  >
                    <div className="h-5 w-28 rounded bg-gray-300" />
                    <div className="h-5 w-16 rounded bg-gray-300" />
                  </div>
                ))}

                <div className="mt-3 flex items-start justify-center gap-3">
                  <div className="h-8 w-20 rounded bg-gray-300" />
                  <div className="h-8 w-20 rounded bg-gray-300" />
                </div>
              </div>
            </Card>
          ))
        ) : containerError ? (
          <div className="col-span-full flex items-center justify-center gap-2 text-red-500">
            <RiErrorWarningFill className="h-6 w-6" />
            <span>{containerError}</span>
          </div>
        ) : containerList?.length > 0 ? (
          containerList.map((container, index) => (
            <CardContainers
              key={container._id ?? index}
              containerDetails={container}
              refreshList={refreshList}
            />
          ))
        ) : (
          <p className="col-span-full text-center text-gray-500">
            No containers found.
          </p>
        )}
      </div>
    </div>
  );
};

export default ContainerPage;
